import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {get, ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {IRoll} from '@/types/Roll';
import {Game} from '@/types/Interfaces';
import {NormalRoll} from '@/types/NormalRoll';

@Component
export class RollMixin extends Vue {
    @Prop() game!: Game;
    secret = false;
    normalRollText = '';

    async addRoll(roll: IRoll): Promise<void> {
        if (!this.game.characters[this.$store.state.user.uid].rolls) {
            this.game.characters[this.$store.state.user.uid].rolls = [];
        }
        this.game.characters[this.$store.state.user.uid].rolls = [roll, ...this.game.characters[this.$store.state.user.uid].rolls];
        if (this.game.characters[this.$store.state.user.uid].rolls.length > 20) this.game.characters[this.$store.state.user.uid].rolls.pop();
        await set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}/rolls`), this.game.characters[this.$store.state.user.uid].rolls);
    }

    async addGlobalRoll(roll: IRoll): Promise<void> {
        let globalRolls: IRoll[] | null = null;
        await get(ref(db, `/jdrs/${this.game.id}/rolls`)).then(snap => {
            globalRolls = snap.val();
        });
        if (globalRolls === null) globalRolls = [];
        globalRolls = [roll, ...globalRolls];
        globalRolls = globalRolls.slice(0, 100);
        await set(ref(db, `/jdrs/${this.game.id}/rolls`), globalRolls);
    }

    async rollNormal(): Promise<void> {
        const roll = new NormalRoll(this.secret, this.game.type, this.game.characters[this.$store.state.user.uid].name);
        roll.roll(this.normalRollText);
        await this.addRoll(roll);
        await this.addGlobalRoll(roll);
    }
}
